import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AccountIconName } from 'src/app/models/accountSettings.model';

@Component({
    standalone: false,
    selector: 'app-account-icon',
    templateUrl: './account-icon.component.html',
    styleUrls: ['./account-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountIconComponent {
    @Input({ required: true }) name!: AccountIconName;
    @Input() size = 18;
    @Input() strokeWidth = 2;
}
